/* eslint-disable */
export const AUTH_PERSIST_KEY = `bds:auth`;

export const AUTH_SERVICE_ROLE_SUPER_ADMIN = `SUPER_ADMIN`;
export const AUTH_SERVICE_ROLE_ADMIN = `ADMIN`;
export const AUTH_SERVICE_ROLE_STANDARD = `STANDARD`;
export const AUTH_SERVICE_ROLE_BATCHER = `BATCHER`;

export const AUTH_SERVICE_STORAGE_ENTITY_KEY = `entity`;
